import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowDownOutlined, ArrowUpOutlined } from "@common-packages/react-icons";
import { Dropdown } from "@digdir/designsystemet-react";
import { useState } from "react";
import "./AirportSwitcher.scss";
import { AvinorColor } from "@constants";
import { useIataContext } from "@contexts/IataContext";
import { useMenuContext } from "@contexts/MenuContext";
const AirportSwitcher = () => {
    const { iata, setIata } = useIataContext();
    const [open, setOpen] = useState(false);
    const { setMenuOpen } = useMenuContext();
    const options = [
        { value: "BGO", label: "BGO" },
        { value: "OSL", label: "OSL" },
        { value: "TRD", label: "TRD" },
        { value: "SVG", label: "SVG" },
    ];
    const handleChange = (selectedValue) => {
        setIata(selectedValue);
        setOpen(false);
    };
    const toggleSwitcher = (value) => {
        if (value) {
            setMenuOpen(false);
        }
        setOpen(value);
    };
    return (_jsx("div", { className: "airport-switcher", children: _jsxs(Dropdown.TriggerContext, { children: [_jsxs(Dropdown.Trigger, { asChild: true, onClick: () => toggleSwitcher(!open), className: "airport-switcher__button", children: [_jsx("span", { children: iata }), open ? (_jsx(ArrowUpOutlined, { color: AvinorColor.HeaderTextSubtle, width: "0.625rem" })) : (_jsx(ArrowDownOutlined, { color: AvinorColor.HeaderTextSubtle, width: "0.625rem" }))] }), _jsx(Dropdown, { open: open, "data-size": "sm", onClose: () => toggleSwitcher(false), children: _jsx(Dropdown.List, { children: options.map((option) => (_jsx(Dropdown.Item, { onClick: () => handleChange(option.value), children: _jsx(Dropdown.Button, { children: option.label }) }, option.value))) }) })] }) }));
};
export default AirportSwitcher;
